type OrganisationRoute = {
  name: string;
  path: string;
  requireAuth?: boolean;
};

const organisationRoutes: Record<string, OrganisationRoute> = {
  settings: {
    name: 'OrganisationSettings',
    path: '/organisation/settings',
    requireAuth: true,
  },
} as const;

export default organisationRoutes;
